import useBreakpoint from "hooks/useBreakpoint";
import HeaderDesktop from "./HeaderDesktop";
import HeaderMobile from "./HeaderMobile";

const Header = (props) => {
  const { isMobile } = useBreakpoint();
  return isMobile ? <HeaderMobile {...props} /> : <HeaderDesktop {...props} />;
};

export default Header;
